<template>
  <EditorPopover ref="popover" @cancel="popoverCancelButtonClick()">

    <TabbedBox>
      <template v-slot:tablist>
        <Tab :first="true" tabid="tab-tool">
          <i :class="['far', icon]"></i> {{title}}
        </Tab>
      </template>

      <template v-slot:tabcontent>
        <TabPage :first="true" tabid="tab-tool">

          <div v-html="convertNewlinesToBreaks(toolInfoText)"></div>          

          <EditorPopoverButtonList>
            <EditorPopoverButton icon="fa-times" type="cancel" title="Cancel" @click="popoverCancelButtonClick()" />
            <template v-if="editingEnabled">
              <EditorPopoverButton
                v-for="(button, index) of actionButtons"
                :key="index"
                :icon="button.icon"
                :type="button.type"
                :title="button.title"
                :disabled="button.disabled"
                @click="popoverActionButtonClick(button.tag)" />
            </template>
          </EditorPopoverButtonList>
        </TabPage>
      </template>
    </TabbedBox>  

    

  </EditorPopover>
</template>

<style scoped>
.entry-error-area {
  height: 1rem;
  min-height: 1rem;
  font-size: 0.65rem;
}
</style>

<script>
import _ from 'lodash'
import EditorPopover from '@glass-designer/components/editorPopover'
import EditorPopoverMixin from '@glass-designer/mixins/editorPopover'
import EditorKeypad from '@glass-designer/components/editorKeypad'
import EditorTypes from '@glass-designer/types'
import MathsUtils from '@/utils/mathsUtils'

import EditorPopoverButtonList from '@glass-designer/components/popover/editorPopoverButtonList'
import EditorPopoverButton from '@glass-designer/components/popover/editorPopoverButton'

export default {
  name: 'EditorToolSettingsPopover',
  mixins: [EditorPopoverMixin],
  components: {
    EditorPopover,
    EditorKeypad,
    EditorPopoverButtonList,
    EditorPopoverButton
  },
  props: {
    editingEnabled: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      actionButtons: [],
      title: '',
      icon: 'fa-tools',
      toolInfoText: ''      
    }
  },
  methods: {
    setup(editor, options) {
      this.clearOptions()

      options = _.defaults(options, {
        actionButtons: [],
        infoText: '',
        title: '',
        icon: 'fa-tools'
      })

      this.actionButtons = options.actionButtons
      this.toolInfoText = options.infoText
      this.title = options.title
      this.icon = options.icon

      // Setup callbacks next tick so they don't get called when resetting values
      this.callbackContext = options.context
      this.updateCallback = options.updateCallback
      this.applyCallback = options.applyCallback
      this.actionCallback = options.actionCallback
      this.cancelCallback = options.cancelCallback
    },
    clearOptions() {
      this.callbackContext = null
      this.updateCallback = null
      this.applyCallback = null
      this.actionCallback = null
      this.cancelCallback = null
    },
    displayToolPopover(containerEl, editor, displayOptions) {
      this.$refs.popover.displayToolPopover(containerEl, editor, displayOptions)
    },
    viewportUpdated(containerEl, editor) {
    },
    hide() {
      if(this.cancelCallback) {
        // Reset cancel CB so it only is called once when hiding popovers
        let cancelCB = this.cancelCallback
        this.cancelCallback = null

        cancelCB(this.callbackContext, false)
      }

      this.clearOptions()
      this.$refs.popover.hide()
    },
    cancelEditing() {
      if(this.cancelCallback)
        this.cancelCallback(this.callbackContext, true)

      this.clearOptions()
      this.hide()
    },
    onShortcutKey(code) {
      switch(code) {
        case 'Escape':
          this.cancelEditing()
          break
      }
    },
    onAction(eventInfo) {
      if(this.applyCallback) {
        this.applyCallback(this.callbackContext, {
          actionTag: eventInfo
        })
      }
    }
  }
}
</script>